import React, { useMemo } from "react";
import {
    StepContent,
    StepContainer,
    VideoWrapper,
    FileRow,
    FileCheckIcon,
    FileName,
    RemoveLink,
    StepActions,
    StepInfo,
    ActionButtons,
    BackLink,
    RedButton,
} from "../survey.styled";

interface SecondStepProps {
    video: File;
    onBack: () => void;
    onSubmit: () => void;
    onRemove: () => void;
}

const SecondStep: React.FC<SecondStepProps> = ({ video, onBack, onSubmit, onRemove }) => {
    const videoUrl = useMemo(() => URL.createObjectURL(video), [video]);

    return (
        <StepContent>
            <StepContainer style={{ maxWidth: 960, padding: '0 5px' }}>
                <VideoWrapper>
                    <video controls>
                        <source src={videoUrl} type={video.type || 'video/mp4'} />
                    </video>
                </VideoWrapper>
                <FileRow>
                    <FileCheckIcon />
                    <FileName>Swing 1</FileName>
                    <RemoveLink
                        href="#"
                        onClick={(e: React.MouseEvent<HTMLElement>) => { e.preventDefault(); onRemove(); }}
                    >
                        Remove
                    </RemoveLink>
                </FileRow>
                <StepActions>
                    <StepInfo>
                        <p>Ready to send this video to your coach? <br />Tap the &ldquo;Submit Swing&rdquo; button.</p>
                        <p>(You can upload additional swing videos in a later step).</p>
                    </StepInfo>
                    <ActionButtons>
                        <BackLink
                            href="#"
                            onClick={(e: React.MouseEvent<HTMLElement>) => { e.preventDefault(); onBack(); }}
                        >
                            Back
                        </BackLink>
                        <RedButton onClick={onSubmit}>
                            Upload Swing Video
                        </RedButton>
                    </ActionButtons>
                </StepActions>
            </StepContainer>
        </StepContent>
    );
};

export default SecondStep;